import styled from 'styled-components'
import { Box } from '@branch-messenger/willow-ui'

export const StyledFullScreenLoaderContainer = styled(Box).attrs({
  $display: 'flex',
  $justify: 'center',
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: ${({ theme }) => theme.colors.surface};
`
